import React, { lazy } from 'react';
import { APP_INFO } from 'config';
import { IRoute } from './@types';
import ROUTE_PATHS from './values';

// import SignUpView from 'views/SignUp/SignUp.view';
// import OnBoardingView from 'views/OnBoarding/OnBoarding.view';
// import PaywallView from 'views/Paywall/Paywall.view';
// import DownloadView from 'views/Download/Download.view';
// import FromQuizView from 'views/FromQuiz/FromQuiz.view';
// import LandingView from 'views/Landing/Landing.view';
// import PPView from 'views/PP/PP.view';

const SignUpView = lazy(() => import('views/SignUp/SignUp.view'));
const OnBoardingView = lazy(() => import('views/OnBoarding/OnBoarding.view'));
const PaywallView = lazy(() => import('views/Paywall/Paywall.view'));
const DownloadView = lazy(() => import('views/Download/Download.view'));
const FromQuizView = lazy(() => import('views/FromQuiz/FromQuiz.view'));
const LandingView = lazy(() => import('views/Landing/Landing.view'));
const PPView = lazy(() => import('views/PP/PP.view'));
const ChatIntro = lazy(() => import('views/ChatIntro/ChatIntro.view'));
const ChatView = lazy(() => import('views/Chat/Chat.view'));
const ChatSignUpView = lazy(() => import('views/ChatSignUp/ChatSignUp.view'));

const getRootComponent = (): React.FC => {
  let View = SignUpView;

  if (APP_INFO.isPaywallDomain) {
    View = PaywallView;
  }

  if (APP_INFO.isPPDomain) {
    View = PPView;
  }

  return View;
};

const Routes: IRoute[] = [
  {
    path: ROUTE_PATHS.ROOT,
    Component: getRootComponent(),
    exact: true,
    showMenu: false,
    requireAuth: APP_INFO.isPaywallDomain || APP_INFO.isPPDomain,
  },
  {
    path: ROUTE_PATHS.SIGN_UP,
    Component: SignUpView,
    exact: true,
    showMenu: false,
    requireAuth: false,
  },
  {
    path: ROUTE_PATHS.OB,
    Component: OnBoardingView,
    exact: true,
    showMenu: false,
    requireAuth: true,
  },
  {
    path: ROUTE_PATHS.PAYWALL,
    Component: PaywallView,
    exact: true,
    showMenu: false,
    requireAuth: true,
  },
  {
    path: ROUTE_PATHS.PAYWALL_PAYMENT,
    Component: PaywallView,
    exact: true,
    showMenu: false,
    requireAuth: true,
  },
  {
    path: ROUTE_PATHS.DOWNLOAD,
    Component: DownloadView,
    exact: true,
    showMenu: false,
    requireAuth: false,
  },
  {
    path: ROUTE_PATHS.FROM_QUIZ,
    Component: FromQuizView,
    exact: true,
    showMenu: false,
    requireAuth: false,
  },
  {
    path: ROUTE_PATHS.LANDING,
    Component: LandingView,
    exact: true,
    showMenu: false,
    requireAuth: false,
  },
  {
    path: ROUTE_PATHS.PP,
    Component: PPView,
    exact: true,
    showMenu: false,
    requireAuth: true,
  },
  {
    path: ROUTE_PATHS.WELCOME_TO_CHAT,
    Component: ChatIntro,
    exact: true,
    showMenu: false,
    requireAuth: false,
  },
  {
    path: ROUTE_PATHS.CHAT,
    Component: ChatView,
    exact: true,
    showMenu: false,
    requireAuth: false,
  },
  {
    path: ROUTE_PATHS.CHAT_SIGN_UP,
    Component: ChatSignUpView,
    exact: true,
    showMenu: false,
    requireAuth: false,
  },
];

export default Routes;
